import { BaseEntityDtoAny } from "@/common/ts/entity";

import TableCellContentOfAffiliation from "./TableCellContentOfAffiliation";

interface Props {
  entity: Nil<BaseEntityDtoAny>;
}

export default function TableCellContentOfAffiliationInDepartments({ entity }: Props) {
  return (
    <TableCellContentOfAffiliation
      entity={entity}
      displayProps={{
        tenant: false,
        departments: true,
        locations: false,
      }}
    />
  );
}
